import { Link } from "wouter";
import { MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Shown instead of every stat section when the workspace has no assets.
 *
 * One action, not two: Tab 1's manual-entry form and Excel upload dialog both
 * open from local state inside Assessment.tsx and are not route-reachable, so
 * a second "Upload a spreadsheet" link would land the analyst on the same page
 * with nothing open. The copy names both methods instead.
 */
export function DashboardOnboarding() {
  return (
    <section className="flex flex-col items-center gap-4 rounded-xl border border-border bg-card px-6 py-16 text-center shadow-sm">
      <MapPin className="h-10 w-10 text-slate-400 opacity-50" />
      <div className="flex max-w-md flex-col gap-1">
        <h2 className="text-lg font-bold leading-7 text-slate-500">No assets yet</h2>
        <p className="text-sm leading-5 text-slate-400">
          Add your sites and assets to get a climate risk score for each one, per hazard. You can enter
          them one at a time or upload a spreadsheet.
        </p>
      </div>
      <Button asChild>
        <Link href="/assessment#site-data">Add your assets</Link>
      </Button>
    </section>
  );
}
